module.exports = __webpack_public_path__ + "static/media/desktopLogin2.e513a256.png";